import React from "react";
import { Box } from "atoms";

export const Card = ({ children, ...props }) => {
  return (
    <Box bg="white" p="2.4rem" borderRadius="1rem" {...props}>
      {children}
    </Box>
  );
};
